// IDs estáticos preservam os valores de texto usados no cadastro PJ.
export const formasConstituicao = [
  {
    "id": "",
    "descricao": "Selecione"
  },
  {
    "id": "2",
    "descricao": "S. A."
  },
  {
    "id": "3",
    "descricao": "Limitada"
  },
  {
    "id": "4",
    "descricao": "Sociedade de Capital e Indústria"
  },
  {
    "id": "5",
    "descricao": "Assoc. Civil (Ent. Soc./Clube/Igreja/Fund.)"
  },
  {
    "id": "6",
    "descricao": "Sociedade Comandita por Ações"
  },
  {
    "id": "7",
    "descricao": "Sociedade Civil com Fins Lucrativos"
  },
  {
    "id": "8",
    "descricao": "Sociedade em Conta Participação"
  },
  {
    "id": "9",
    "descricao": "Cooperativa Rural/de Crédito/Habit."
  },
  {
    "id": "10",
    "descricao": "Filial/Sucursal/Ag. Empr. Sediada no Exterior"
  },
  {
    "id": "11",
    "descricao": "Empresa Pública"
  }
];

export const listaAssinaturas = [
  {
    "id": "",
    "descricao": "Selecione"
  },
  {
    "id": "1",
    "descricao": "Não assina pela empresa"
  },
  {
    "id": "2",
    "descricao": "Assina isoladamente"
  },
  {
    "id": "0",
    "descricao": "Assina em conjunto"
  }
];

export const faixasFinanceiras = [
  {
    "id": "",
    "descricao": "Selecione"
  },
  {
    "id": "1",
    "descricao": "Nenhum"
  },
  {
    "id": "2",
    "descricao": "Até R$ 5.000"
  },
  {
    "id": "3",
    "descricao": "De R$ 5.001 até R$ 10.000"
  },
  {
    "id": "4",
    "descricao": "De R$ 10.001 até R$ 30.000"
  },
  {
    "id": "5",
    "descricao": "De R$ 30.001 até R$ 50.000"
  },
  {
    "id": "6",
    "descricao": "De R$ 50.001 até R$ 100.000"
  },
  {
    "id": "7",
    "descricao": "Acima de R$ 100.001"
  }
];
